import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile'
import { getCountryForTimezone } from 'countries-and-timezones'

// The regions a phone's own number is likely local to: the browser's and the
// time zone's. Safari reports only the languages Apple ships, so an English
// phone is en-US or en-GB whatever its region is set to; the time zone says
// where the phone is.
const homeRegions = () => {
  const regions = new Set()
  try {
    regions.add(new Intl.Locale(navigator.language).maximize().region)
  } catch {
    // No language to read: the time zone alone.
  }
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
    regions.add(getCountryForTimezone(timeZone)?.id)
  } catch {
    // No time zone to read: the language alone.
  }
  regions.delete(undefined)
  return [...regions]
}

// A number filled in as it is saved, often without its country code, as
// (408) 477-5401 or 07911 123456, takes the code of the one home region it
// is a valid mobile number in, without the + the field shows. One valid in
// two (Mexico's 55 1234 5678 is a US number too) or in none is left as it
// is, for its owner to add the code. Applied twice, it changes nothing more.
export const withCountryCode = (number) => {
  const found = new Set(
    homeRegions()
      .map((region) => parsePhoneNumberFromString(number, region))
      .filter((parsed) => parsed?.isValid())
      .map((parsed) => parsed.formatInternational())
  )
  return found.size === 1 ? [...found][0].slice(1) : number
}

// Whether the browser filled the field: Safari keeps it marked, in its
// yellow, until it is edited. matches throws on a pseudo-class it lacks.
export const isAutofilled = (input) =>
  [':autofill', ':-webkit-autofill'].some((selector) => {
    try {
      return input.matches(selector)
    } catch {
      return false
    }
  })
